import React from 'react';
import './StartScreen.css';

const StartScreen = ({ onStartGame }) => {
  return (
    <div className="start-screen">
      <div className="game-title">
        <h1>컬러 퍼즐 러시</h1>
        <p className="subtitle">같은 색상의 블록을 연결하여 점수를 획득하세요!</p>
      </div>
      
      <div className="game-modes">
        <h2>게임 모드</h2>
        
        <div className="mode-buttons">
          <button 
            className="mode-button arcade" 
            onClick={() => onStartGame('arcade')}
          >
            <h3>아케이드 모드</h3>
            <p>60초 안에 최대한 많은 점수를 획득하세요!</p>
          </button>
          
          <button 
            className="mode-button challenge" 
            onClick={() => onStartGame('challenge')}
          >
            <h3>챌린지 모드</h3>
            <p>특정 목표를 달성하는 단계별 도전!</p>
          </button>
          
          <button 
            className="mode-button zen" 
            onClick={() => onStartGame('zen')}
          >
            <h3>젠 모드</h3>
            <p>시간 제한 없이 릴렉싱하게 플레이하세요.</p>
          </button>
        </div>
      </div>
      
      <div className="how-to-play">
        <h2>게임 방법</h2>
        <ul>
          <li>같은 색상의 블록을 3개 이상 연결하세요</li>
          <li>연속으로 블록을 제거하면 콤보 점수가 올라갑니다</li>
          <li>특수 블록을 활용하여 더 많은 점수를 획득하세요</li>
          <li>💣 폭탄 블록: 주변 블록을 모두 제거합니다</li>
          <li>🌈 레인보우 블록: 어떤 색상과도 연결할 수 있습니다</li>
        </ul>
      </div>
      
      <div className="footer">
        <p>© 2025 SWYG 모바일 게임</p>
      </div>
    </div>
  );
};

export default StartScreen;
